export default __webpack_public_path__ + "static/media/left_education_background_circle.99f67ade.svg";